import { lazy } from 'react';

export const TeacherCoursesPage = lazy(() => import('./TeacherCoursesPage'));
